import { formatMinorAmount, type Locale } from '@owner/localization'

import { getActiveLocale } from '@/core/store/composables/useLocale'

/**
 * The bare currency symbol, for surfaces that render it apart from the amount —
 * a prefix affix on a money input, say. Prefer {@link CurrencyFormatter}
 * wherever the symbol and amount are rendered together, so their placement
 * stays correct for the locale.
 *
 * Derived by subtracting the unsymbolled rendering from the symbolled one so
 * that the symbol can never disagree with the one `formatMinorAmount` would
 * print for the same config.
 * @param config
 */
export const currencySymbol = (config: Locale = getActiveLocale()): string =>
  formatMinorAmount(0, config).replace(
    formatMinorAmount(0, config, { includeSymbol: false }),
    ''
  )
